import { useEffect, useState } from "react";
import { Input, InputGroup, InputGroupText } from "reactstrap"
import { FIELD_TYPES } from "../fields";

export const ColumnFilter = ({ getSearchText, column, previousData, applyFilter }) => {
    const { filtervalue, setFilter } = column;
    const [dateRange, setDateRange] = useState({ start: '', end: '' });

    useEffect(() => {
        // Initialize date range from previous data if it exists
        const prevData = previousData.filter(item =>
            item.field_id === (column.data?.id || column.id)
        )[0];

        if (prevData && prevData.search_value) {
            if (typeof prevData.search_value === 'object' && prevData.search_value.start) {
                setDateRange(prevData.search_value);
            }
        }
    }, [previousData, column]);

    const isDateField = column.data?.field_type === "dateField" || column.field_type === "dateField";

    const handleDateRangeChange = (type, value) => {
        const newRange = { ...dateRange, [type]: value };
        setDateRange(newRange);

        // Trigger on any change
        getSearchText(column, newRange);
    };


    const handleSingleInputChange = (value) => {
        getSearchText(column, value);
    };

    const getPreviousValue = () => {
        const filtered = previousData.filter(item =>
            item.field_id === (column.data?.id || column.id)
        );
        return filtered.length > 0 ? filtered[0].search_value : filtervalue;
    };

    return (
        <div className="search-container">
            {isDateField ? (
                // Date Range Inputs
                <div className="date-range-container">
                    <Input
                        className="search date-range-input"
                        value={dateRange.start}
                        placeholder="From"
                        type="date"
                        onChange={(e) => handleDateRangeChange('start', e.target.value)}
                    />
                    <span className="date-separator">to</span>
                    <Input
                        className="search date-range-input"
                        value={dateRange.end}
                        placeholder="To"
                        type="date"
                        onChange={(e) => handleDateRangeChange('end', e.target.value)}
                    />
                    <span
                        className="search-icon"
                        onClick={() => applyFilter("text")}
                        title="Apply filter"
                    >
                        &#128269;
                    </span>
                </div>
            ) : (
                // Regular Input for non-date fields
                <>
                    {column.data !== undefined ? (
                        <Input
                            className="search"
                            value={getPreviousValue()}
                            placeholder="Search"
                            type={column.data?.field_type === "number" ? 'number' : 'text'}
                            onChange={(e) => handleSingleInputChange(e.target.value)}
                        />
                    ) : (
                        <Input
                            className="search"
                            value={getPreviousValue()}
                            placeholder="Search"
                            type={column.field_type === "number" ? 'number' : 'text'}
                            onChange={(e) => handleSingleInputChange(e.target.value)}
                        />
                    )}
                    <span
                        className="search-icon"
                        onClick={() => applyFilter("text")}
                    >
                        &#128269;
                    </span>
                </>
            )}
        </div>
    );
};